module.exports = __webpack_public_path__ + "img/fondo-planilla.f476b9c9.jpg";